import { CriticalOperationService } from '../services/critical-operation.service';
import { environment } from 'src/environments/environment';
//httpConfig.interceptor.ts
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, defer, throwError } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    loaderToShow: any;
    constructor(private critical: CriticalOperationService
    ) { }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const token = localStorage.getItem('__auth')

        //Authentication by setting header with token value
        if (token && !request.url.includes('amazonaws.com')) {
            request = request.clone({
                setHeaders: {
                    'Authorization': token
                }
            });
        }


        //this.showLoader();
        return defer(() => {
          const isApi = request.url.startsWith(environment.api_url);
          const isMutation = isApi && !['GET', 'HEAD', 'OPTIONS'].includes(request.method);
          const isBillingStatus = isApi && /\/billing\/status(?:\?|$)/.test(request.urlWithParams);
          const isUploadLink = isApi && /\/images\/upload-link(?:\?|$)/.test(request.urlWithParams);
          const isUpload = request.method === 'PUT' && request.body instanceof Blob;
          const end = isMutation || isBillingStatus || isUploadLink || isUpload
            ? this.critical.begin('request in progress') : () => {};
          return next.handle(request).pipe(finalize(end));
        }).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {            
                return throwError(() => error)
            }));
    }




}
